module.exports = __webpack_public_path__ + "static/media/map_5-1.4e806eeb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/v2/map_5-1.svg
// module id = 770
// module chunks = 0